module.exports = __webpack_public_path__ + "static/media/dreidel.56eb4646.svg";